<template>
<div class="spCapitalList">
    <sPCapitalList v-if="user.providerstatus == 10" :hostroletype="hostroletype"></sPCapitalList>
    <serviceProviderTip v-else></serviceProviderTip>
</div>
</template>

<script>
import SPCapitalList from 'views/brandBusiness/capitalMgt/capital/CapitalList.vue'
import {mapGetters, mapActions} from 'vuex'
import ServiceProviderTip from 'views/serviceProvider/components/serviceProviderTip.vue'
export default {
    name: 'CapitalList',
    data() {
        return {
            hostroletype: 4
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        SPCapitalList, ServiceProviderTip
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.spCapitalList {
    .el-pagination{
        margin-top: 20px;
        text-align: center;
    }
}
</style>
